import Button from 'core/display/buttons/Button'
import Image from 'core/display/Image'
import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'

export default class SpinButton {
  constructor(data) {
    this.self = new Image(data)
    this.spin = this.self.images[0]
    this.force = this.self.images[1]
    this.isForced = false
    this.isAuto = false

    this.spin.anchor.set(0.5)
    this.spin.x += this.spin.width / 2
    this.spin.y += this.spin.height / 2
    this.force.visible = false

    this.createSignal()

    return new Button(data, this.self)
  }

  createSignal(){
    const out = this

    signal.on('REELS-START', out.start.bind(out))
    signal.on('REELS-STOP', out.stop.bind(out))
    signal.on('STATE:IN:AUTO', () => out.isAuto = true)
    signal.on('STATE:OUT:AUTO', () => out.isAuto = false)
  }

  start() {
    this.isForced = false
    signal.once('BUTTON:spin', this.forced.bind(this))
    const startTween =  gsap.to(this.spin, 0.5, {
      rotation: `+=${Math.PI * 2}`,
      onComplete: () => {
        startTween.kill()
        this.animated()
      },
    })
  }

  stop() {
    signal.off('BUTTON:spin', this.forced.bind(this))
    this.spin.visible = true
    this.force.visible = false
  }

  animated() {
    this.spin.visible = this.isForced || this.isAuto
    this.force.visible = !this.isForced && !this.isAuto
  }

  forced() {
    this.isForced = true
    this.spin.visible = true
    this.force.visible = false
  }
}
